import { Outlet } from "react-router-dom";

function Home() {
    return (
        <>
            <Outlet />
        </>

    );
}

export default Home;